import Echo from '@ably/laravel-echo';

import { WebsocketService } from '../websockets';

type PrivateChannel = ReturnType<Echo['private']>;

export class PrivateEchoWebsocketService extends WebsocketService<PrivateChannel> {
  constructor() {
    super({
      channelApi: {
        connect: (echo, channelName) => echo.private(channelName),
        leave: (echo, channelName) => echo.leave(channelName),
        listen: (channel, eventName, handler) => {
          channel.listen(eventName, handler);
        },
        stopListening: (channel, eventName, handler) => {
          channel.stopListening(eventName, handler);
        },
      },
    });
  }
}
